// Impact section configuration
// Defines fields for social/environmental impact and SDG alignment
import { z } from 'zod';
import type { SectionConfig } from '../../types/sections';

// Validation schema for impact section
export const impactSectionSchema = z.object({
  socialEnvironmentalImpact: z.string().min(1, 'Este campo es requerido'),
  sdgContribution: z.array(z.string()).min(1, 'Selecciona al menos un ODS'),
  impactMeasurement: z.string().min(1, 'Este campo es requerido'),
});

export type ImpactSectionData = z.infer<typeof impactSectionSchema>;

// Section config
export const impactSection: SectionConfig = {
  id: 'impact',
  titleKey: 'Impacto',
  descriptionKey: 'Impacto social y ambiental de tu solución',
  validationSchema: impactSectionSchema,
  fields: [
    {
      name: 'socialEnvironmentalImpact',
      type: 'textarea',
      label: '¿Qué impacto social o ambiental genera tu solución?',
      placeholder: 'Describe el impacto de tu solución...',
      required: true,
    },
    {
      name: 'sdgContribution',
      type: 'multiselectDropdown',
      label: '¿A qué ODS contribuye?',
      required: true,
      options: [
        { value: 'no-poverty', label: 'Fin de la pobreza' },
        { value: 'zero-hunger', label: 'Hambre cero' },
        { value: 'good-health', label: 'Salud y bienestar' },
        { value: 'quality-education', label: 'Educación de calidad' },
        { value: 'gender-equality', label: 'Igualdad de género' },
        { value: 'clean-water', label: 'Agua limpia y saneamiento' },
        { value: 'affordable-energy', label: 'Energía asequible y no contaminante' },
        { value: 'decent-work', label: 'Trabajo decente y crecimiento económico' },
        { value: 'industry-innovation', label: 'Industria, innovación e infraestructura' },
        { value: 'reduced-inequalities', label: 'Reducción de las desigualdades' },
        { value: 'sustainable-cities', label: 'Ciudades y comunidades sostenibles' },
        { value: 'responsible-consumption', label: 'Producción y consumo responsables' },
        { value: 'climate-action', label: 'Acción por el clima' },
        { value: 'life-below-water', label: 'Vida submarina' },
        { value: 'life-on-land', label: 'Vida de ecosistemas terrestres' },
        { value: 'peace-justice', label: 'Paz, justicia e instituciones sólidas' },
        { value: 'partnerships', label: 'Alianzas para lograr los objetivos' },
      ],
    },
    {
      name: 'impactMeasurement',
      type: 'textarea',
      label: '¿Cómo mides ese impacto?',
      placeholder: 'Describe cómo mides y evalúas el impacto...',
      required: true,
    },
  ],
};
